import React from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

// Files Import
import { content } from "../../../data";
import { Link } from "react-router-dom";
import StyledSmText from "../../../common/components/styledSmText/StyledSmText";
import StyledH5Heading from "../../../common/components/styledH5Heading/StyledH5Heading";

const responsive = {
  0: { items: 1 },
  600: { items: 2 },
  1024: { items: 3 },
  1200: { items: 4 },
};

const TeamCarousel = () => {
  const carouselStyle = `
    .TeamCarousel .alice-carousel__stage {
   
      max-width: 100%;
      min-width: 100%;
    }
    .TeamCarousel .alice-carousel__dots-item:not(.__custom):hover, .alice-carousel__dots-item:not(.__custom).__active {
      background-color: yellow;
  }
    .TeamCarousel .alice-carousel__dots-item:not(.__custom) {
      width: 10px !important;
      height: 10px !important;
    
  }
    @media (min-width: 1200px) {
      .alice-carousel__dots {
        display: none !important;
      }
    }
  `;

  return (
    <>
      <style>{carouselStyle}</style>
      <AliceCarousel
        disableButtonsControls
        responsive={responsive}
        items={content.Artist.map((item, index) => (
          <div
            key={index}
            className="bg-light-black p-4 pb-6 rounded-[18px] flex flex-col justify-center items-center gap-6 mx-2" // Added mx-4 for horizontal margins
          >
            <div className="w-full overflow-hidden rounded-2xl">
              <img src={item.imgUrl} alt="Artist" className="w-full" loading="lazy"/>
            </div>
            <div>
              <StyledH5Heading fontColor={"text-bright-yellow"}>
                {item.Name}
              </StyledH5Heading>
              <StyledSmText>{item.Profession}</StyledSmText>
            </div>
            <div className="flex gap-4 -mt-3">
              {item.socialIcon.map((iconItem, iconIndex) => (
                <Link
                  className="group hover:-translate-y-[3px] duration-200"
                  key={iconIndex}
                  to={iconItem.link}
                  target="_blank"
                >
                  {iconItem.icon}
                </Link>
              ))}
            </div>
          </div>
        ))}
      />
    </>
  );
};

export default TeamCarousel;
